<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="flex items-start gap-3">
    <UIcon name="i-lucide-credit-card" aria-hidden="true" class="mt-0.5 size-5 shrink-0 text-brand-600 dark:text-brand-400" />
    <div class="min-w-0">
      <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
        <p class="text-sm font-semibold text-brand-800 dark:text-brand-200">{{ t('financing.noFees') }}</p>
        <span class="rounded bg-pink-100 px-2 py-0.5 text-xs font-semibold text-gray-900">Klarna</span>
      </div>
      <p class="mt-1 text-xs leading-5 text-gray-600 dark:text-gray-300">{{ t('financing.checkoutHint') }}</p>
    </div>
  </div>
</template>
